import React, { useEffect, useState } from 'react'
import { router } from '@components/Router/Router'
import { theme } from '@misc/theme'
import { ThemeProvider } from '@mui/material'
import { ReactQueryProvider } from '@providers/ReactQueryProvider'
import { RouterProvider } from 'react-router-dom'
import { initReactI18next } from 'react-i18next'
import { enLocalisation } from './locales/en'
import ConfigProvider from '@plug-core/providers/ConfigProvider'
import BalanceProvider from '@plug-core/providers/BalanceProvider'
import WalletProvider from '@plug-core/providers/WalletProvider'
import { GoogleAnalyticsProvider } from '@plug-core/providers/GoogleAnalyticsProvider'
import { initializeI18n } from '@plug-core/utils/initializeI18n'
import ToastProvider from '@providers/ToastProvider'
import ExtensionContainer from '@components/ExtensionContainer'
import { IdleTimer } from '@components/IdleTimer'
import AccountLogger from '@components/AccountLogger'
import LockGuard from '@components/LockGuard'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { initializeWalletHandlers } from '@/entries/background/index.web'

// Initialize plug-core messenger first to create the global singleton
import '@plug-core/messengers'

const queryClient = new QueryClient()

initializeI18n(initReactI18next, enLocalisation)

// Initialize wallet handlers after messenger is available
// This ensures messenger handlers are ready when components mount
initializeWalletHandlers()

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <ExtensionContainer>
          <ReactQueryProvider>
            <ConfigProvider>
              <ToastProvider>
                <GoogleAnalyticsProvider>
                  <IdleTimer />
                  <LockGuard>
                    <WalletProvider>
                      <BalanceProvider>
                        <AccountLogger />
                        <RouterProvider router={router} />
                      </BalanceProvider>
                    </WalletProvider>
                  </LockGuard>
                </GoogleAnalyticsProvider>
              </ToastProvider>
            </ConfigProvider>
          </ReactQueryProvider>
        </ExtensionContainer>
      </ThemeProvider>
    </QueryClientProvider>
  )
}